/** Normalize user_breaks.video_link from API (array or legacy single string). */
export function normalizeUserBreakVideoLinks(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((u) => String(u ?? '').trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map((u) => String(u ?? '').trim()).filter(Boolean);
        }
      } catch {
        // fall through
      }
    }
    if (trimmed.includes(',')) {
      return trimmed
        .split(',')
        .map((u) => String(u ?? '').trim())
        .filter(Boolean);
    }
    return [trimmed];
  }
  return [];
}

export function hasUserBreakVideos(raw) {
  return normalizeUserBreakVideoLinks(raw).length > 0;
}
